import { provideZoneChangeDetection } from "@angular/core";
/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function actualizarMetaRobots() {
  const metaTag = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
  if (metaTag) {
    metaTag.content = environment.production ? 'index,follow' : 'noindex,nofollow';
  }
}

Sentry.init({
  dsn: environment.sentryDsn,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: true,
      blockAllMedia: false,
    })
  ],
  tracesSampleRate: 0.2,
  tracePropagationTargets: ["localhost", /^https:\/\/pruebas\.certificadostradicionylibertad\.co\/api/],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: false,
  beforeSend(event) {
    if (event.request?.data && typeof event.request.data === 'object') {
      const campos = ['cardNumber', 'cvv', 'cvc', 'expiryDate', 'password'];
      campos.forEach((campo) => {
        if (campo in (event.request!.data as any)) {
          (event.request!.data as any)[campo] = '[Filtered]';
        }
      });
    }
    return event;
  },
});

function bootstrap() {
  actualizarMetaRobots();
  platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
};

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
